// Asegúrate de que el DOM esté completamente cargado antes de inicializar
// document.addEventListener('DOMContentLoaded', function() {

//   // Inicializa Lenis
//   const lenis = new Lenis({
//     duration: 1.2, // Duración del scroll
//     easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)), // Curva de easing
//     direction: 'vertical', // o 'horizontal'
//     gestureDirection: 'vertical', // o 'horizontal'
//     smooth: true,
//     mouseMultiplier: 1,
//     smoothTouch: false,
//     touchMultiplier: 2,
//     infinite: false,
//   });

//   // Si estás usando ScrollTrigger con GSAP, regístralo con Lenis
//   if (typeof gsap !== 'undefined' && typeof ScrollTrigger !== 'undefined') {
//     lenis.on('scroll', ScrollTrigger.update);

//     gsap.ticker.add((time) => {
//       lenis.raf(time * 1000); // Llama a raf de Lenis en cada tick de GSAP
//     });

//     gsap.ticker.lagSmoothing(0); // Deshabilita el lag smoothing de GSAP para evitar conflictos
//   }

//   // Función para manejar el scroll con Lenis
//   function raf(time) {
//     lenis.raf(time);
//     requestAnimationFrame(raf);
//   }

//   requestAnimationFrame(raf);


//   // Puedes registrar GSAP con Lenis también si necesitas el control más fino del scroll
//   // document.documentElement.classList.add('lenis'); // Opcional: añade una clase para estilos específicos

//   // ... (código de inicialización de Lenis y GSAP) ...

//     gsap.to("#contenedor", {
//     rotation: 360,   // Rota 360 grados
//     duration: 2,     // Duración de la animación en segundos
//     ease: "power2.inOut", // Curva de easing
//     delay: 1,        // Retraso antes de que la animación empiece
//     scrollTrigger: { // Si usas ScrollTrigger
//         trigger: ".my-element",
//         start: "top 80%", // La animación empieza cuando el top del elemento alcanza el 80% del viewport
//         end: "bottom 20%",
//         scrub: true, // La animación se vincula al scroll
//         markers: true // Para depuración, muestra marcadores en el viewport
//     }
//     });

// });

// Scroll reveal reutilizable con mask-image en degradado (GSAP + ScrollTrigger).
// A diferencia de un clip-path recto, el borde del barrido es angulado: se puede orientar
// para que siga la diagonal natural de un trazo/línea dibujada en el SVG en vez de un corte
// puramente horizontal o vertical.
// Marca cualquier elemento con la clase "js-scroll-reveal" y configúralo con data-attributes:
//   data-reveal-angle     ángulo del barrido en grados, mismo sistema que linear-gradient:
//                         0 = de abajo hacia arriba, 90 = de izquierda a derecha,
//                         180 = de arriba hacia abajo, 270 = de derecha a izquierda.
//                         Cualquier valor intermedio (ej. 65) sigue una diagonal — úsalo
//                         para alinear el barrido con la inclinación real del trazo. (default: 0)
//   data-reveal-feather   ancho del borde suave del barrido, en % (default: 35)
//   data-reveal-duration  segundos, ej. "1.2" (default: 1.2)
//   data-reveal-ease      easing de GSAP (default: power2.out)
//   data-reveal-start     punto de inicio del ScrollTrigger (default: "top 75%")
//   data-reveal-toggle    toggleActions del ScrollTrigger (default: "play none none reverse")
//   data-reveal-trigger   selector del ancestro a usar como trigger (default: "section")
(function () {
  function buildMask(angle, pos, feather) {
    var half = feather / 2;
    return (
      'linear-gradient(' + angle + 'deg,' +
      ' #000 0%,' +
      ' #000 calc(' + pos + '% - ' + half + '%),' +
      ' transparent calc(' + pos + '% + ' + half + '%),' +
      ' transparent 100%)'
    );
  }

  function initScrollReveal() {
    if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') {
      setTimeout(initScrollReveal, 100);
      return;
    }

    gsap.registerPlugin(ScrollTrigger);

    document.querySelectorAll('.js-scroll-reveal').forEach(function (el) {
      var angle = parseFloat(el.dataset.revealAngle) || 0;
      var feather = parseFloat(el.dataset.revealFeather) || 35;
      var trigger = el.closest(el.dataset.revealTrigger || 'section') || el;
      var startPos = -feather / 2;
      var endPos = 100 + feather / 2;

      function applyMask(pos) {
        var mask = buildMask(angle, pos, feather);
        el.style.WebkitMaskImage = mask;
        el.style.maskImage = mask;
      }

      applyMask(startPos);

      gsap.to({ pos: startPos }, {
        pos: endPos,
        duration: parseFloat(el.dataset.revealDuration) || 1.2,
        ease: el.dataset.revealEase || 'power2.out',
        onUpdate: function () {
          applyMask(this.targets()[0].pos);
        },
        scrollTrigger: {
          trigger: trigger,
          start: el.dataset.revealStart || 'top 85%',
          toggleActions: el.dataset.revealToggle || 'play none none reverse'
        }
      });
    });
  }

  document.addEventListener('DOMContentLoaded', initScrollReveal);
})();

// Contador reutilizable que anima un número de 0 hasta un valor objetivo al
// entrar en el viewport (GSAP + ScrollTrigger).
// Marca cualquier elemento con la clase "js-count-up" y configúralo con data-attributes:
//   data-count-to          valor final numérico, ej. "6292" (requerido)
//   data-count-prefix      texto antes del número, ej. "+" (default: "")
//   data-count-suffix      texto después del número, ej. "%" (default: "")
//   data-count-separator   separador de miles, ej. "," o "." (default: ",", usa "" para ninguno)
//   data-count-decimals    número de decimales a mostrar (default: 0)
//   data-count-duration    segundos, ej. "1.5" (default: 1.5)
//   data-count-ease        easing de GSAP (default: power1.out)
//   data-count-start       punto de inicio del ScrollTrigger (default: "top 85%")
//   data-count-toggle      toggleActions del ScrollTrigger (default: "play none none reverse")
//   data-count-trigger     selector del ancestro a usar como trigger (default: el propio elemento)
(function () {
  function formatNumber(value, separator, decimals) {
    var fixed = decimals > 0 ? value.toFixed(decimals) : Math.round(value).toString();
    var parts = fixed.split('.');
    if (separator) {
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, separator);
    }
    return parts.join('.');
  }

  function initCountUp() {
    if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') {
      setTimeout(initCountUp, 100);
      return;
    }

    gsap.registerPlugin(ScrollTrigger);

    document.querySelectorAll('.js-count-up').forEach(function (el) {
      var target = parseFloat(el.dataset.countTo);
      if (isNaN(target)) return;

      var prefix = el.dataset.countPrefix || '';
      var suffix = el.dataset.countSuffix || '';
      var separator = el.dataset.countSeparator !== undefined ? el.dataset.countSeparator : ',';
      var decimals = parseInt(el.dataset.countDecimals, 10) || 0;
      var trigger = el.dataset.countTrigger ? el.closest(el.dataset.countTrigger) : el;
      var counter = { value: 0 };

      function applyValue(value) {
        el.textContent = prefix + formatNumber(value, separator, decimals) + suffix;
      }

      applyValue(0);

      gsap.to(counter, {
        value: target,
        duration: parseFloat(el.dataset.countDuration) || 1.5,
        ease: el.dataset.countEase || 'power1.out',
        onUpdate: function () {
          applyValue(counter.value);
        },
        scrollTrigger: {
          trigger: trigger,
          start: el.dataset.countStart || 'top 85%',
          toggleActions: el.dataset.countToggle || 'play none none reverse'
        }
      });
    });
  }

  document.addEventListener('DOMContentLoaded', initCountUp);
})();

// Reveal reutilizable de izquierda a derecha al entrar en el viewport (IntersectionObserver).
// A diferencia de "js-scroll-reveal" (GSAP ScrollTrigger, basado en la posición de scroll de
// la página), este usa IntersectionObserver puro. El CSS que oculta el elemento (clip-path)
// solo se activa una vez que este script corre (clase "js-reveal-ready" en <html>), para que
// nunca quede invisible de forma permanente si el JS no llegara a ejecutarse.
// Marca cualquier elemento con la clase "js-reveal-ltr" (el CSS del wipe está en critical.css)
// y configúralo con data-attributes:
//   data-reveal-duration   segundos que dura el barrido (default: 1)
//   data-reveal-delay      segundos de retraso antes de iniciar (default: 0)
//   data-reveal-threshold  porcentaje visible necesario para disparar, 0-1 (default: 0.15)
//   data-reveal-once       "true" anima solo la primera vez; por defecto (false) se repite
//                          cada vez que el elemento vuelve a hacerse visible, ideal para
//                          imágenes que un carousel oculta y muestra repetidamente
//   data-reveal-trigger    selector de un ancestro estable a observar en su lugar (default:
//                          el propio elemento). Útil cuando el elemento vive dentro de un
//                          slide de carousel que se oculta con display:none, ya que ese
//                          display:none puede hacer que el propio elemento nunca "intersecte"
//                          — en cambio el contenedor del carousel siempre está en el layout.
(function () {
  function initRevealLtr() {
    var els = document.querySelectorAll('.js-reveal-ltr');
    if (!els.length) return;

    document.documentElement.classList.add('js-reveal-ready');

    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-revealed'); });
      return;
    }

    els.forEach(function (el) {
      var duration = parseFloat(el.dataset.revealDuration) || 1;
      var delay = parseFloat(el.dataset.revealDelay) || 0;
      var once = el.dataset.revealOnce === 'true';
      var threshold = parseFloat(el.dataset.revealThreshold);
      if (isNaN(threshold)) threshold = 0.15;
      var triggerSelector = el.dataset.revealTrigger;
      var triggerEl = (triggerSelector && document.querySelector(triggerSelector)) || el;

      el.style.transitionDuration = duration + 's';
      el.style.transitionDelay = delay + 's';

      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            el.classList.add('is-revealed');
            if (once) observer.unobserve(triggerEl);
          } else if (!once) {
            el.classList.remove('is-revealed');
          }
        });
      }, { threshold: threshold });

      observer.observe(triggerEl);
    });
  }

  document.addEventListener('DOMContentLoaded', initRevealLtr);
})();